import ActionBarItem from '@rio-cloud/rio-uikit/ActionBarItem';
import { FormattedMessage } from 'react-intl';
import { useSearchParams } from 'react-router';

import { createDebugConfig, trackCustomEvent } from '@/configuration/setup/googleAnalytics';
import { USER_MANUAL_TAB_PARAM } from '@/features/userManual/utils';
import { useWhatsNewStore } from '@/stores/whatsNewStore';

export const UserManualMenu = () => {
    const [, setSearchParams] = useSearchParams();
    const { showNotification: showWhatsNewBadge } = useWhatsNewStore();

    const handleMenuItemClick = (keyPage: string) => {
        setSearchParams({ [USER_MANUAL_TAB_PARAM]: keyPage });

        const eventName = `open_${
            keyPage === 'fleetMonitor' ? 'find_charging_stations' : keyPage === 'overview' ? 'functions' : keyPage
        }`;
        trackCustomEvent(
            eventName,
            { trigger: 'click', flow_name: 'user_manual', element_name: 'click_on_user_manual_menu' },
            createDebugConfig()
        );
    };

    return (
        <div>
            <ActionBarItem.List className='line-height-largest'>
                <ActionBarItem.ListItem
                    data-testid='hand-right-icon'
                    icon='rioglyph-hand-right'
                    onClick={() => handleMenuItemClick('welcome')}
                >
                    <FormattedMessage id='userManual.sections.welcome.title' />
                </ActionBarItem.ListItem>
                <ActionBarItem.ListItem
                    data-testid='exclamation-sign-icon'
                    icon='rioglyph-exclamation-sign'
                    onClick={() => handleMenuItemClick('whatsNew')}
                >
                    <div className='display-flex align-items-center'>
                        <FormattedMessage id='userManual.sections.whatsNew.title' />
                        {showWhatsNewBadge && <span className='badge badge-primary margin-left-5' />}
                    </div>
                </ActionBarItem.ListItem>
                <ActionBarItem.ListItem
                    data-testid='question-sign-icon-for-faq'
                    icon='rioglyph-question-sign'
                    onClick={() => handleMenuItemClick('faq')}
                >
                    <FormattedMessage id='userManual.sections.faq.title' />
                </ActionBarItem.ListItem>
                <ActionBarItem.ListItem
                    data-testid='poi-icon'
                    icon='rioglyph-poi rioglyph-filled text-size-14 margin-1'
                    className='align-items-center'
                    onClick={() => handleMenuItemClick('fleetMonitor')}
                >
                    <FormattedMessage id='userManual.sections.findChargingStations.title' />
                </ActionBarItem.ListItem>
                <ActionBarItem.ListItem
                    data-testid='question-sign-icon'
                    icon='rioglyph-question-sign'
                    onClick={() => handleMenuItemClick('overview')}
                >
                    <FormattedMessage id='userManual.menu.title' />
                </ActionBarItem.ListItem>
            </ActionBarItem.List>
        </div>
    );
};
